<main class="cd-main">
  <!-- HEADER -->
  <div class="cd-header-row">
    <div>
      <h1 class="cd-title">Bulk Assign Students</h1>
      <p class="cd-subtitle">Assign students to staff members via CSV</p>
    </div>
    <div class="header-actions">
      <button
        mat-stroked-button
        class="cd-draft-btn"
        (click)="assign()"
        aria-label="Confirm bulk assignment"
      >
        Confirm Assignment
      </button>
    </div>
  </div>

  <form [formGroup]="form" aria-label="Bulk assign students form">
    <div class="ce-main">
      <mat-card class="ce-card" appearance="outlined">
        <mat-card-content>
          <h2 class="ce-section-title">Student Assign Upload</h2>
          <p class="cd-subtitle" style="font-size: 12px; margin-bottom: 8px">
            Upload a CSV file to bulk assign students to staff members. The file should have two
            columns,
            <code class="ce-format-hint-code">staff_email</code> and
            <code class="ce-format-hint-code">student_email</code>, with one row per assignment.
          </p>
          <div class="ce-format-hint">
            <div class="ce-format-hint-title">Expected CSV format</div>
            <p class="cd-subtitle" style="font-size: 12px; margin-bottom: 6px">
              Two columns with a header row:
              <code class="ce-format-hint-code">staff_email</code> and
              <code class="ce-format-hint-code">student_email</code>. One row per assignment.
            </p>
            <table class="ce-format-hint-table">
              <thead>
                <tr>
                  <th>staff_email</th>
                  <th>student_email</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>jsmith&#64;district.org</td>
                  <td>asmith&#64;district.org</td>
                </tr>
                <tr>
                  <td>jsmith&#64;district.org</td>
                  <td>bwilliams&#64;district.org</td>
                </tr>
                <tr>
                  <td>kdoe&#64;district.org</td>
                  <td>cjohnson&#64;district.org</td>
                </tr>
              </tbody>
            </table>
          </div>
          <input
            #csvInput
            type="file"
            accept=".csv,text/csv"
            style="display: none"
            aria-label="Upload student-staff assignment CSV"
            (change)="onCsvAdded($event)"
          />

          <div
            class="ce-upload-dropzone"
            role="button"
            tabindex="0"
            aria-label="Click to upload assignment CSV"
            (click)="csvInput.click()"
            (keydown.enter)="csvInput.click()"
            (keydown.space)="csvInput.click()"
          >
            <mat-icon class="ce-upload-icon" aria-hidden="true">description</mat-icon>
            <div class="ce-upload-label">Click to upload assignment CSV</div>
            <div class="ce-upload-hint">.csv (staff_email, student_email columns)</div>
          </div>

          @if (form.get('csvFile')!.value) {
            <p class="cd-subtitle" style="font-size: 12px; margin-top: 8px">
              Selected: {{ form.get('csvFile')!.value?.name }}
            </p>
          }

          @if (form.get('csvFile')!.touched && form.get('csvFile')!.hasError('required')) {
            <p class="ce-error" style="color: #b3261e; font-size: 12px; margin-top: 4px">
              Please upload a CSV file.
            </p>
          }

          @if (form.get('csvFile')!.hasError('invalidType')) {
            <p class="ce-error" style="color: #b3261e; font-size: 12px; margin-top: 4px">
              Only .csv files are supported.
            </p>
          }

          @if (form.get('csvFile')!.hasError('tooLarge')) {
            <p class="ce-error" style="color: #b3261e; font-size: 12px; margin-top: 4px">
              File is too large. Max size is 10MB.
            </p>
          }
        </mat-card-content>
      </mat-card>
    </div>
  </form>
</main>
